const contact = {
  phone_number: "+7 (499) 390-42-86",
};
export const HTTP_STATUS = {
  SUCCESS: 200,
};
export default contact;
